import React from 'react';
import Avatar from '@mui/joy/Avatar';
import Box from '@mui/joy/Box';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import { getInitials } from '../utils/getInitials';

interface TableCustomerCellProps {
  name: string;
  subtitle?: string;
}

const TableCustomerCell: React.FC<TableCustomerCellProps> = ({ name, subtitle }) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
      <Avatar size="sm" variant="soft" color="primary" sx={{ '--Avatar-size': '28px' }}>
        {getInitials(name || '?')}
      </Avatar>
      <Box sx={{ minWidth: 0 }}>
        <Typography level="body-sm" fontWeight="lg" noWrap>
          {name || '—'}
        </Typography>
        {subtitle ? (
          <Typography level="body-xs" sx={{ color: 'text.tertiary' }} noWrap>
            {subtitle}
          </Typography>
        ) : null}
      </Box>
    </Stack>
  );
};

export default TableCustomerCell;
